import type { PropsWithChildren } from "react"
import { JourneyCard } from "../JourneyCard"
import { type Data as JourneyProduct } from "../JourneyCard/gql"
import s from "./JourneyProducts.module.scss"

type JourneyProductsProps = {
  products: JourneyProduct[]
  isLocked: boolean
}
export const JourneyProducts = ({
  products,
  isLocked,
}: JourneyProductsProps) => {
  return (
    <div className={s.products}>
      {products.map((product) => (
        <JourneyCardBlock key={product!.id}>
          <JourneyCard data={product} isLocked={isLocked} />
        </JourneyCardBlock>
      ))}
    </div>
  )
}

export const JourneyCardBlock = ({ children }: PropsWithChildren) => (
  <div className={s.journeyBlock}>
    <div>{children}</div>
  </div>
)
